import Dinero from 'dinero.js';
import { isCurrencyCode } from '@pepperhq/regions';
import { isDefined } from 'lib/typeguards';
import { PepperTransaction, PepperTransactionCapturedAmountSummary } from '../../model/PepperPay';

export interface FormattedCapturedAmountTotal {
    currency: string;
    formatted: string;
}

export function capturedAmountSummaryFromTransaction(
    transaction: PepperTransaction
): PepperTransactionCapturedAmountSummary {
    const capturedAmount = isDefined(transaction.paymentIntent?.amountReceived)
        ? transaction.paymentIntent.amountReceived
        : transaction.total;
    const currency = isCurrencyCode(transaction.currency) ? transaction.currency : 'GBP';
    return {
        currencies: [{ currency, capturedAmount, count: 1 }]
    };
}

export function formatCapturedAmountTotals(
    summary: PepperTransactionCapturedAmountSummary
): FormattedCapturedAmountTotal[] {
    if (!summary.currencies.length) {
        return [{ currency: 'GBP', formatted: Dinero({ amount: 0, currency: 'GBP' }).toFormat() }];
    }
    return summary.currencies.map(entry => {
        const currency = isCurrencyCode(entry.currency) ? entry.currency : 'GBP';
        return {
            currency,
            formatted: Dinero({ amount: entry.capturedAmount, currency }).toFormat()
        };
    });
}
